export const GET_EVENT_ALL='GET_EVENT_ALL'
export const GET_EVENT_DETAIL='GET_EVENT_DETAIL'
export const GET_EVENT_IMAGE='GET_EVENT_IMAGE'
export const GET_PUBLIC_WORKSHOP='GET_PUBLIC_WORKSHOP'
export const GET_PUBLIC_WORKSHOP_MOBILE='GET_PUBLIC_WORKSHOP_MOBILE'